import {ItemType} from 'antd/es/menu/interface';

export function getIsUserAvailable(isWgisSupportUser: boolean): boolean {
    return !isWgisSupportUser;
}

function getMenuItemFlatKeys(
    menuItems: Array<ItemType>,
    parentKeys?: Array<React.Key>
): Array<[React.Key, Array<React.Key>]> {
    return menuItems.flatMap((item) => {
        if (!item || !item.key) {
            return [];
        }

        const itemKeysPath = [...(parentKeys ?? []), item.key];

        return [
            [item.key, itemKeysPath],
            ...(item.type === 'submenu' && item.children ? getMenuItemFlatKeys(item.children, itemKeysPath) : []),
        ];
    });
}

export function getPathNameToSelectedKeysMap(menuItems: Array<ItemType>): Map<React.Key, Array<string>> {
    const resultMap = new Map();

    getMenuItemFlatKeys(menuItems).forEach(([key, selectedKeys]) => {
        if (!resultMap.has(key)) {
            resultMap.set(key, selectedKeys);
        }
    });

    return resultMap;
}
